// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

const {ccclass, property} = cc._decorator;

@ccclass
export default class BullTurnNumCom extends cc.Component {

    private numLabel : cc.Label = null;
    private showNumber : number;


    onLoad(){

        this.numLabel = this.node.getComponent(cc.Label);

    }

    show(num : number){

        this.showNumber = num;

        this.node.active = num > 0;
        
        this.updateNum(num);
    }

    private updateNum( num : number ){

        this.numLabel.string = num.toString();
    }

    onTriggered() {
        
        this.showNumber -= 2;        
    
        this.show( Math.max(0,this.showNumber) );
        
    }
}
